export enum stepTypes {
  FETCH_STEP_REQUEST = "FETCH_STEP_REQUEST",
  FETCH_STEP_SUCCESS = "FETCH_STEP_SUCCESS",
  FETCH_STEP_FAILURE = "FETCH_STEP_FAILURE",
}